import React, { useEffect, useState } from "react";
import { Container, Row, Col, Spinner } from "reactstrap";
import CallCountCards from "./CallCountCards";
import { URL } from "../../api.jsx";
import axiosInstance from "../../axiosInstance";
import "./collectionCallerRemarks.css";

const CollectionCallerRemarks = () => {
  const [counts, setCounts] = useState(null);
  const [loading, setLoading] = useState(false);

  // Logged-in caller info
  const callerId = localStorage.getItem("userId");
  const callerName = localStorage.getItem("username");

  const fetchCallCounts = async () => {
    try {
      setLoading(true);

      const response = await axiosInstance.get(URL.CALL_COUNT, {
        params: {
          callerId: callerId || null, // safe for admin also
        },
      });

      setCounts(response.data);
    } catch (err) {
      console.error("Failed to load call counts:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCallCounts();
  }, []);

  return (
    <Container fluid className="caller-remarks-page">
      {/* PAGE TITLE */}
      <Row className="mb-2">
        <Col>
          <h4 className="page-title">📞 Caller Remarks Dashboard</h4>
        </Col>
      </Row>

      {/* CALLER INFO STRIP */}
      <Row className="mb-3">
        <Col>
          <div className="caller-info-bar">
            <span>
              <strong>User Name:</strong> {callerName || "-"}
            </span>
            <span className="ms-4">
              <strong>Caller ID:</strong> {callerId || "-"}
            </span>
          </div>
        </Col>
      </Row>

      {/* COUNT CARDS */}
      {loading ? (
        <div className="text-center mt-5">
          <Spinner color="primary" />
        </div>
      ) : (
        counts && <CallCountCards data={counts} />
      )}

    </Container>
  );
};

export default CollectionCallerRemarks;
